import EditVM from './edit-vm';

export default {
  init(element) {
    const forumThreadData = document.getElementById('forum_thread_json').value
    const ele = document.getElementById('editor-container');
    ko.applyBindingsWithValidation(
      new EditVM(forumThreadData, ele),
      ele,
      Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS
    );
  }
};
